import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-6" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-title\"><div class=\"d-flex align-items-center position-relative my-1\"><span class=\"svg-icon svg-icon-1 position-absolute ms-6\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><rect opacity=\"0.5\" x=\"17.0365\" y=\"15.1223\" width=\"8.15546\" height=\"2\" rx=\"1\" transform=\"rotate(45 17.0365 15.1223)\" fill=\"black\"></rect><path d=\"M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z\" fill=\"black\"></path></svg></span><input type=\"text\" data-kt-user-table-filter=\"search\" class=\"form-control form-control-solid w-250px ps-14\" placeholder=\"Search user\"></div></div>", 1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  class: "d-flex justify-content-end",
  "data-kt-user-table-toolbar": "base"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "11.364",
      y: "20.364",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-90 11.364 20.364)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "4.36396",
      y: "11.364",
      width: "16",
      height: "2",
      rx: "1",
      fill: "black"
    })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Add User ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-end align-items-center d-none\" data-kt-user-table-toolbar=\"selected\"><div class=\"fw-bolder me-5\"><span class=\"me-2\" data-kt-user-table-select=\"selected_count\"></span>Selected </div><button type=\"button\" class=\"btn btn-danger\" data-kt-user-table-select=\"delete_selected\"> Delete Selected </button></div><div class=\"modal fade\" id=\"kt_modal_export_users\" tabindex=\"-1\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-centered mw-650px\"><div class=\"modal-content\"><div class=\"modal-header\"><h2 class=\"fw-bolder\">Export Users</h2><div class=\"btn btn-icon btn-sm btn-active-icon-primary\" data-kt-users-modal-action=\"close\"><span class=\"svg-icon svg-icon-1\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><rect opacity=\"0.5\" x=\"6\" y=\"17.3137\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(-45 6 17.3137)\" fill=\"black\"></rect><rect x=\"7.41422\" y=\"6\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(45 7.41422 6)\" fill=\"black\"></rect></svg></span></div></div><div class=\"modal-body scroll-y mx-5 mx-xl-15 my-7\"><form id=\"kt_modal_export_users_form\" class=\"form\" action=\"#\"><div class=\"fv-row mb-10\"><label class=\"fs-6 fw-bold form-label mb-2\">Select Roles:</label><select name=\"role\" data-control=\"select2\" data-placeholder=\"Select a role\" data-hide-search=\"true\" class=\"form-select form-select-solid fw-bolder\"><option></option><option value=\"Administrator\">Administrator</option><option value=\"Analyst\">Analyst</option><option value=\"Developer\">Developer</option><option value=\"Support\">Support</option><option value=\"Trial\">Trial</option></select></div><div class=\"fv-row mb-10\"><label class=\"required fs-6 fw-bold form-label mb-2\">Select Export Format:</label><select name=\"format\" data-control=\"select2\" data-placeholder=\"Select a format\" data-hide-search=\"true\" class=\"form-select form-select-solid fw-bolder\"><option></option><option value=\"excel\">Excel</option><option value=\"pdf\">PDF</option><option value=\"cvs\">CVS</option><option value=\"zip\">ZIP</option></select></div><div class=\"text-center\"><button type=\"reset\" class=\"btn btn-light me-3\" data-kt-users-modal-action=\"cancel\"> Discard </button><button type=\"submit\" class=\"btn btn-primary\" data-kt-users-modal-action=\"submit\"><span class=\"indicator-label\">Submit</span><span class=\"indicator-progress\">Please wait... <span class=\"spinner-border spinner-border-sm align-middle ms-2\"></span></span></button></div></form></div></div></div></div>", 2)
const _hoisted_10 = { class: "card-body pt-0" }
const _hoisted_11 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "kt_table_users"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-10px pe-2" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid me-3" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          "data-kt-check": "true",
          "data-kt-check-target": "#kt_table_users .form-check-input",
          value: "1"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "User"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Role"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Last login"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Two-step"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Joined Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end min-w-100px" }, "Actions")
  ])
], -1)
const _hoisted_13 = { class: "text-gray-600 fw-bold" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "checkbox",
      value: "1"
    })
  ])
], -1)
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { href: "../../demo1/dist/apps/user-management/users/view.html" }
const _hoisted_17 = { class: "symbol-label me-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "../../demo1/dist/apps/user-management/users/view.html",
    class: "text-gray-800 text-hover-primary mb-1"
  }, "Emma Smith"),
  /*#__PURE__*/_createElementVNode("span", null, "e.smith@kpmg.com.au")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "Administrator", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "badge badge-light fw-bolder" }, "Yesterday")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "20 Dec 2021, 6:05 pm", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-light btn-active-light-primary btn-sm",
    "data-kt-menu-trigger": "click",
    "data-kt-menu-placement": "bottom-end"
  }, [
    /*#__PURE__*/_createTextVNode("Actions "),
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-5 m-0" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4",
    "data-kt-menu": "true"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "../../demo1/dist/apps/user-management/users/view.html",
        class: "menu-link px-3"
      }, "Edit")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "menu-link px-3",
        "data-kt-users-table-filter": "delete_row"
      }, "Delete")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElNotification = _resolveComponent("ElNotification")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      _ctx.isInviteUser.message ===
      'Success create user with groups ! please verify your email'
    )
      ? (_openBlock(), _createBlock(_component_ElNotification, {
          key: 0,
          title: "Success",
          message: _ctx.isInviteUser.message,
          type: "success",
          duration: 2000
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChangeStateModal && _ctx.handleChangeStateModal(...args))),
            type: "button",
            class: "btn btn-primary"
          }, _hoisted_7)
        ]),
        _hoisted_8,
        (_ctx.modalState.type !== '')
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalState.type), {
              key: 0,
              payload: _ctx.modalState.payload
            }, null, 8, ["payload"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("table", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("tbody", _hoisted_13, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (item) => {
            return _createElementVNode("tr", { key: item }, [
              _hoisted_14,
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Avatar, {
                        shape: "round",
                        "first-name": "Emma",
                        "last-name": "Smith"
                      })
                    ])
                  ]),
                  _hoisted_18
                ])
              ]),
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23
            ])
          }), 64))
        ])
      ])
    ])
  ], 64))
}